import { render, staticRenderFns } from "./DeliveryProductCreate.vue?vue&type=template&id=346e6555&scoped=true"
import script from "./DeliveryProductCreate.vue?vue&type=script&lang=js"
export * from "./DeliveryProductCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "346e6555",
  null
  
)

export default component.exports